import { createBasicSelector } from 'util/redux'
import { selectPreferences } from './selectPreferences'

export const selectPreferredInboxTheme = createBasicSelector(
  selectPreferences,
  preferences => {
    return preferences.inbox_theme || 'light'
  }
)
